'use client'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

type PhucHuynhActionsProps = {
  className?: string
}

/** Cặp nút "Mua ngay" (cuộn tới listing) + "Khám phá BST khác" */
export const PhucHuynhActions = ({ className }: PhucHuynhActionsProps) => {
  const t = useTranslations('phuc_huynh_hardcode.cta')

  return (
    <div
      className={cn(
        'grid w-full gap-2 md:flex md:w-auto md:flex-wrap md:gap-4 2xl:gap-6',
        className
      )}
    >
      <Button
        size='large'
        variant='black'
        className='h-[50px] px-10'
        onClick={() => {
          document.getElementById('collection-listing')?.scrollIntoView({
            behavior: 'smooth',
          })
        }}
      >
        {t('buy_now')}
        <ArrowRight className='!size-5' />
      </Button>
      <Button
        asChild
        size='large'
        variant='outline-neutral'
        className='h-[50px] px-10'
      >
        <Link href='/highlight-collections'>
          {t('explore_more')}
          <ArrowRight className='!size-5' />
        </Link>
      </Button>
    </div>
  )
}
